import {
  useMutation as _useMutation,
  useQuery as _useQuery,
} from 'react-query';

import { useHasAuth } from 'lib/DataStore';
import { QlEndPoint, QlType } from '.';
import { sendRequest } from '../../core';
//new api calls
export namespace SavedSearch {
  const key = () => [QlEndPoint.SAVED_SEARCH, 'sadas'];
  const request = () => {
    const params: QlType.SavedSearchParams = {
      page:0,
      size: 20,
    };
    return sendRequest<QlType.SavedSearchNewVersion>({
      method: 'get',
      url: QlEndPoint.SAVED_SEARCH_NEW_VERSION,
      config: {
        params,
      },
    });
  };
  export const useSavedSearch = () => {
    const hasAuth = useHasAuth();
    return _useQuery(key(), () => request().then((res) => res.data), {
      retryOnMount: false,
      enabled: hasAuth,
    });
  };
}

export namespace CreateSaveSearch {
  const request = (body: QlType.SavedSearchCreateNewVersion) => {
    return sendRequest<QlType.SaveSearchCreateResponseNewVersion>({
      method: 'post',
      url: QlEndPoint.PUBLISH_NEW_VERSION,
      body,
    });
  }

  export const useMutation = (
    onSuccess: (_data: QlType.SaveSearchCreateResponseNewVersion | null) => void
  ) =>
    _useMutation(
      (body: QlType.SavedSearchCreateNewVersion) => request(body)
        .then((res) => res.data)
        .catch((e) => {
          console.log('error', e);
          return e.data.data
            ;
        }),
      {
        onSuccess,
      },
    );
}

export namespace CreateSaveSearchDirect {
  const request = (body: QlType.DirectSaveSearch) => {
    return sendRequest<QlType.SaveSearchCreateResponseNewVersion>({
      method: 'post',
      url: QlEndPoint.PUBLISH_AGENCY_NEW_VERSION,
      body,
    });
  }
  export const useMutation = (
    onSuccess: (_data: QlType.SaveSearchCreateResponseNewVersion | null) => void
  ) =>
    _useMutation(
      (body: QlType.DirectSaveSearch) => request(body)
        .then((res) => res.data)
        .catch((e) => {
          console.log('error', e);
          return e.data.data
            ;
        }),
      {
        onSuccess,
      },
    );

}

// export namespace ConnectionType {
export namespace UpdateNotification {
  const request = (id: number, body: QlType.ConnectionTypeBody) =>
    sendRequest<QlType.ConnectionTypeResponse>({
      method: 'put',
      url: QlEndPoint.UPDATE_NOTIFICATION(id),
      body,
    });

  export const useNotificationTypeMutation = (onSuccess?: () => void) => {
    return _useMutation(
      ({ id, body }: { id: number; body: QlType.ConnectionTypeBody }) => {
        return request(id, body).then((res) => res);
      },
      {
        onSuccess,
      }
    );
  };
}

export namespace DeleteSaveSearch {
  const request = (id: number | string) =>
    sendRequest({
      method: 'delete',
      url: QlEndPoint.DELETE_SAVE_SEARCH_NEW_VERSION(id),
    });
  export const useMutation = () =>
    _useMutation(
      (id: number | string) => request(id).then((res) => {
        console.log("response in send request ",res);
        return res;
      })
    );
}

//end new api calls
export namespace EditSaveSearch {
  type EditSaveSearch = { title: string };
  const request = (id: number | undefined, params: EditSaveSearch) =>
    sendRequest({
      method: 'put',
      url: QlEndPoint.EDIT_SAVE_SEARCH(id),
      body: params,
    });

  export const useMutation = (id: number | undefined) => {
    return _useMutation((body: EditSaveSearch) =>
      request(id, body).then((res) => res.data)
    );
  };
}

export namespace Ladder {
  const request = (id: number | string) =>
    sendRequest<QlType.Ladder>({
      method: 'patch',
      url: QlEndPoint.LADDER(id),
    });
  export const useMutation = (
    id: number | string,
    _onSuccess?: (_data: QlType.Ladder) => void
  ) => {
    return _useMutation(() => request(id).then((res) => res.data), {
      onSuccess(data) {
        if (_onSuccess && data) _onSuccess(data);
      },
    });
  };
}
